export default __webpack_public_path__ + "static/media/redMarker.cc1b211e.svg";